import { DvirReportState } from '../types';

export const dvirReportsState: DvirReportState = {
  reports: [],
  dataRetentionDvir: 3,
};
